import { GqlHealth } from 'src/services'

export type EvaluationText = {
  title: string
  description: string
}

export const variationText: Record<GqlHealth, EvaluationText> = {
  GREEN: {
    title: 'High Variation',
    description:
      'There is significant variation seen in the target tag showing a good possibility for optimization.',
  },
  YELLOW: {
    title: 'Decent Variation',
    description:
      'There is limited variation seen in the target tag meaning the possibility for optimization is uncertain.',
  },
  RED: {
    title: 'Low Variation',
    description:
      'There is little to no variation seen in the target tag showing a poor possibility for optimization.',
  },
}

export const forecastText: Record<GqlHealth, EvaluationText> = {
  GREEN: {
    title: 'High Forecast Quality',
    description:
      'The data sufficiently explains the variation in the target tag. This allows us to predict future behavior well and make recommendations based on a good understanding of the process.',
  },
  YELLOW: {
    title: 'Decent Forecast Quality',
    description:
      'The data explains some variation in the target tag. It is uncertain if we can predict future behavior well enough to make useful recommendations.',
  },
  RED: {
    title: 'Low Forecast Quality',
    description:
      'The data does not explain the variation in the target tag. We are unable to predict the future behavior well and therefore recommendations would be based on a poor understanding of the process.',
  },
}

export const improvementText: Record<GqlHealth, EvaluationText> = {
  GREEN: {
    title: 'Potential improvement',
    description:
      'We were able to find recommendations that we predict will improve the process.',
  },
  YELLOW: {
    title: 'Potential improvement',
    description:
      'We were only able to find recommendations that we predict will give limited improvement in the process.',
  },
  RED: {
    title: 'Potential improvement',
    description:
      'We were unable to find recommendations that we predict will improve the process.',
  },
}
